import KeenSlider from 'keen-slider'

const CarouselId = 'carousel';
const mode = 'free-snap';

const init = () => {

  if(!document.getElementById(CarouselId)) {
    return;
  }

  new KeenSlider(`#${CarouselId}`, {
    loop: true,
    slidesPerView: 3,
    spacing: 16,
    mode,
    breakpoints: {
      '(min-width: 1024px)': {
        slidesPerView: 5,
        mode,
      },
    },
    created: instance => {
      const prevBtn = document.getElementById('keen-prev');
      if(prevBtn) {
        prevBtn.addEventListener('click', () => instance.prev());
      }
      const nextBtn = document.getElementById('keen-next');
      if(nextBtn) {
        nextBtn.addEventListener('click', () => instance.next());
      }
    },
  });
};

export default {init};
